import React from 'react';
import { space } from 'helpers/style'
import styled from 'styled'
import { EventPointOfInterest } from 'generated/mos/org/getty/audio'

const CALENDAR_KIND_TITLES = {
  CALENDAR_UNPECIFIED: "Unpecified",
  CALENDAR_EXHIBITIONS: "Exhibitions",
  CALENDAR_PERFORMANCES: "Performances",
  CALENDAR_FILM: "Film",
  CALENDAR_FAMILY: "Family",
  CALENDAR_FOOD: "Food",
  CALENDAR_TOURS: "Tours",
  CALENDAR_TALKS: "Talks",
  CALENDAR_COURSES: "Courses",
}

const Badge = styled.div`
  display: inline-block;
  margin-right: ${space(3)};
  padding: 1px 2px;
  border: 1px solid ${({ theme }) => theme.color.grayL20};
  border-radius: 2px;
  font-size: 10px;
  color: ${({ theme }) => theme.color.gray};
  font-weight: ${({ theme }) => theme.font.weight.light};
  text-transform: uppercase;
`

export const calendarTitles = ({calendars}: Exclude<EventPointOfInterest.Entity['event'], undefined>) => calendars
  .filter(({kind}) => kind && kind in CALENDAR_KIND_TITLES)
  .map(({kind}) => (
    <Badge key={kind as keyof typeof CALENDAR_KIND_TITLES}>{CALENDAR_KIND_TITLES[kind as keyof typeof CALENDAR_KIND_TITLES]}</Badge>
  ))

